import { render, staticRenderFns } from "./mapbox.vue?vue&type=template&id=2884be12&scoped=true&"
import script from "./mapbox.vue?vue&type=script&lang=js&"
export * from "./mapbox.vue?vue&type=script&lang=js&"
import style0 from "./mapbox.vue?vue&type=style&index=0&id=2884be12&lang=less&scoped=true&"
import style1 from "./mapbox.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2884be12",
  null
  
)

export default component.exports